import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/header/icon.webp';
import _imports_1 from '../assets/img/header/bili.png';
const _withScopeId = n => (_pushScopeId("data-v-396f3fba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bili-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "关注官方账号", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "客户端下载", -1));
const _hoisted_8 = [_hoisted_7];
import axios from "axios";
import { onMounted, ref } from "vue";
import { downloadFile, createDownloadUrl } from '@/utils/tool.js';

// 创建下载url

export default {
  __name: 'Header',
  setup(__props) {
    createDownloadUrl();
    const isWin7var = ref(false);
    async function getIsWin7() {
      isWin7var.value = await isWin7();
    }
    async function isWin7() {
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      if (ua.indexOf("Windows NT 6.1") > -1 || ua.indexOf("Windows 7") > -1) {
        return true;
      }
      if (navigator.userAgentData) {
        let ua = await navigator.userAgentData.getHighEntropyValues(["platformVersion"]);
        if (ua.platformVersion.split(".")[0] == 0) {
          return true;
        }
      }
      return false;
    }
    const handleDownload = async (maxCount = 5) => {
      if (window.downloadUrl.indexOf("webID") > 0) {
        if (maxCount <= 0) {
          return;
        }
        setTimeout(function () {
          handleDownload(maxCount - 1);
        }, 500);
        return;
      }
      window.collectEvent("invite_im_web_zh_signup_download", {
        current_url: window.location.href
      });
      if (isWin7var.value) {
        downloadFile(window.downloadWin7Url);
      } else {
        // 不是win7都用默认的包
        downloadFile(window.downloadUrl);
      }
      (function (w, n) {
        w[n] = typeof w[n] === "function" ? w[n] : function () {
          (w[n].c = w[n].c || []).push(arguments);
        };
        _qha("send", {
          et: 33,
          ct: 50,
          customData: ["custom", "jzqu50", /*download*/"", ""]
        });
      })(window, "_qha");
    };
    const goToOfficialWebsite = () => {
      window.location.href = "/";
    };
    const handleBili = () => {
      window.collectEvent("invite_web_click_bili");
      let a = document.createElement("a");
      a.href = "https://space.bilibili.com/3537119918164083?spm_id_from=333.337.0.0";
      a.target = "_blank";
      a.click();
      a = null;
    };
    onMounted(() => {
      getIsWin7();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "icon",
        onClick: goToOfficialWebsite
      }, _hoisted_3), _renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", {
        class: "bili-button",
        onClick: handleBili
      }, _hoisted_6), _createElementVNode("div", {
        class: "download-button",
        onClick: _cache[0] || (_cache[0] = $event => handleDownload())
      }, _hoisted_8)])]);
    };
  }
};